import React, { useState, useImperativeHandle, forwardRef, useEffect } from "react";
import FloatLayout from "@/components/float-layout";
import styled from "styled-components";
// import { saveAddrInfo } from '../api';
import { Toast } from "antd-mobile";
import bridge from '@/config/JSbridge'
const Delivery = ({visible = true, onClose, onSubmit}, ref) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [addr, setAddr] = useState('');
  useEffect(()=> {
    bridge.callHandler('nativeEvent', {
      event: 'web_softinput_resize',
      params: {
        isImmersed: true
      }
    }, res => {})
  },[])
  useImperativeHandle(ref, () => {
    return {
      setParams: (addrInfo) => {
        console.log('addrInfo',addrInfo);
        setName(addrInfo.recipientName);
        setPhone(addrInfo.recipientPhone);
        setAddr(addrInfo.recipientAddress);
      }
    }
  })

  const handleSubmit = () => {
    if (!name) {
      Toast.info('请填写收货人');
      return;
    }
    if (!phone) {
      Toast.info('请填写手机号');
      return;
    }
    if (!addr) {
      Toast.info('请填写收货地址');
      return;
    }

    // saveAddrInfo({ activityId: 140, recipientAddress: addr, recipientName: name, recipientPhone: phone }).then(res => {
    //   onSubmit({ recipientName: name, recipientPhone: phone, recipientAddress: addr});
    // })
    onSubmit({ recipientName: name, recipientPhone: phone, recipientAddress: addr});
  }


  return (
    <FloatLayout
      content={
        <LayoutWrap>
          <div className="delivery-title">填写收货信息</div>
          
            <div className="wish-item">
              <div className="wish-item-label">
                <span>收</span>
                <span>货</span>
                <span>人</span>
              </div>
              <div className="wish-input wish-name">
                <input placeholder="请填写收货人姓名" value={name} onChange={e => setName(e.target.value)} className="wish-input-area"/>
              </div>
            </div>

            <div className="wish-item">
              <div className="wish-item-label">
                <span>手</span>
                <span>机</span>
                <span>号</span>
              </div>
              <div className="wish-input wish-name">
                <input placeholder="请填写收货人手机号" value={phone} onChange={e => setPhone(e.target.value)}  className="wish-input-area"/>
              </div>
            </div>

            <div className="wish-item">
              <div className="wish-item-label">
                <span>收</span>
                <span>货</span>
                <span>地</span>
                <span>址</span>
              </div>
              <div className="wish-input wish-content">
                <textarea placeholder="请填写收货地址" value={addr} onChange={e => setAddr(e.target.value)} className="wish-input-area"  />
              </div>
            </div>
    
          <div onClick={handleSubmit} className="delivery-btn">确认提交</div>
          {/* <div className="delivery-desc">奖品会在每月7日前统一邮寄</div> */}
          <div className="delivery-tip">以上信息我们将加密保存，请放心填写</div>
        </LayoutWrap>
      }
      visible={visible}
      onOverlayClick={onClose}
    />
  )
}

export default React.memo(forwardRef(Delivery));

export const LayoutWrap = styled.div`
  position: relative;
  border-radius: 14px 14px 0px 0px;
  background-color: #fff;
  width: 100%;
  color: #3B3B3B;
  padding-top: 24px;
  padding-bottom: 21px;
  .delivery-title {
    font-size: 20px;
    font-weight: 500;
    line-height: 46px;
    text-align: center;
    line-height: 20px;
    margin-bottom: 28px;
  }
  
  .delivery-desc {
    margin-top: 6px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: #2F2F2F;
    line-height: 14px;
  }
  .delivery-tip {
    font-size: 14px;
    font-weight: 400;
    color: #9A988E;
    line-height: 14px;
    text-align: center;
    margin-top: 13px;
  }
  .delivery-btn {
    width: 228px;
    height: 43px;
    background: #FED043;
    border-radius: 21.5px;
    margin: 22px auto 0;

    font-size: 18px;
    font-weight: 500;
    color: #2F2F2F;
    line-height: 43px;
    text-align: center
  }

  .wish-item {
    display: flex;
    padding: 0 25px;
    margin-bottom: 14px;
    .wish-item-label {
      padding-top: 10px;
      font-size: 15px;
      font-weight: 500;
      line-height: 15px;
      margin-right: 15px;
      width: 64px;
      display: flex;
      justify-content: space-between;
    }
    .wish-input {
      flex: 1;
      background: #F1F1F1;
      border-radius: 6px;
    }
    .wish-input-area {
      background: transparent;
      width: 100%;
      height: 100%;
      border: 0;
    }
    .wish-name {
      height: 37px;
    }
    .wish-content {
      height: 82px;
    }
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_135/components/delivery.js